import type {
  Act,
  PreparedAct,
} from '@/types/Acts';

export function prepareAct (act: Act): PreparedAct {
  const firstFile = act.files[0];

  return {
    ...act,
    documentType: firstFile?.slug ?? '',
    fileName: firstFile?.name ?? '',
    files: firstFile?.files ?? [],
  };
}
